jQuery(document).ready(function($) {

    //////////////////////////////
    // Email - Parse JavaScript //
    //////////////////////////////

    $("a.safe").each( function () {
        // Build mail adrees from data-pre and data-post attributes, add as href and node content, and remove target attribute
        $(this).attr('href', 'mailto:' + $(this).data('pre') + '@' + $(this).data('post')).html($(this).data('pre') + '@' + $(this).data('post')).removeAttr('target');
    });
    

    /*
    //////////////////////
    //  Cookie warning  //
    //////////////////////

    // Show cookie warning if not closed before
    if (document.cookie.indexOf("cookieaccepted") < 0) {
        $(".cookiebox").show();
    }

    // Remove cookie warning and remember
    window.setCookieAccepted = function() {
        document.cookie = "cookieaccepted=true; expires=Fri, 3 Aug 2025 12:00:00 UTC; path=/"
        var e = document.getElementsByClassName("cookiebox")[0];
        e.parentNode.removeChild(e);
    }
    */
});
